/**
 * Converts a string to a slug by replacing spaces and non-alphanumeric characters with hyphens.
 *
 * @param {string} title - The string to be slugified.
 * @returns {string} The slugified string.
 */
export function slugify(title) {
    return title
        .toLowerCase() // Convert to lowercase
        .replace(/[\s_]+/g, "-") // Replace spaces and underscores with hyphens
        .replace(/[^a-z0-9-]/g, "") // Remove any remaining non-alphanumeric or hyphen characters
        .replace(/-+/g, "-"); // Remove consecutive hyphens
}
